<template>
  <HeroIdle v-if="showLoadingScreen" />
  <LandingPage v-else-if="!activeParty || partyState != 'live'" />
  <div class="home" v-else-if="activeParty">
    <Stream />
    <div class="chat-container">
      <Chat theme="live" chatType="approvalOnly" :sendToPending="true" />
      <Shopper v-if="streamIsPlaying && shouldShowShoppableLinks" />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex"

import Stream from "@/components/Stream.vue"
import Chat from "@/components/Chat/Chat.vue"
import HeroIdle from "@/components/HeroIdle.vue"
import LandingPage from "@/components/LandingPage"
import Shopper from "@/components/Shopper"
import "@/components/Chat/themeLive.scss"

export default {
  name: "Home",

  data: () => ({
    showLoadingScreen: true
  }),

  components: {
    Chat,
    Stream,
    HeroIdle,
    LandingPage,
    Shopper
  },

  mounted() {
    let partyLink = this.$route.query.party_link

    let isLocalTest =
      process.env.NODE_ENV === "development" && partyLink == "LOCALTEST"

    // LOCAL TESTING RIG
    if (isLocalTest) {
      this.$store.dispatch("partyStore/getPartyFromLocalData", partyLink)
    }

    if (partyLink == undefined) {
      setTimeout(() => {
        this.showLoadingScreen = false
      }, 3000)
    } else if (!isLocalTest) {
      this.$store.dispatch("partyStore/getPartyFromLink", partyLink)
    }
  },
  prop: ["message"],

  created() {
    this.$store.dispatch("identityStore/getLocalStorageId")
  },

  computed: {
    ...mapState("partyStore", ["activeParty", "streamIsPlaying"]),

    ...mapGetters("partyStore", ["shouldShowShoppableLinks"]),

    partyState() {
      return this.activeParty.state
    }
  },

  watch: {
    activeParty(newVal) {
      if (newVal !== null) {
        this.showLoadingScreen = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$white: #ffffff;

.videostream {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.home {
  display: flex;
  height: 100%;
}

.home__login {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.chat-container {
  position: relative;
  flex: 0 0 400px;
  width: 400px;
  height: 100%;

  @media (max-width: 1024px) {
    flex: 0 0 250px;
    width: 250px;
  }

  @media (max-width: 600px) {
    flex: unset;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 600px) {
  .home {
    flex-direction: column;
  }
}
</style>
